import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { useEffect, useState } from "react";

import Hero from "./COMPONENTS/HeroSection";
import AboutSection from "./COMPONENTS/About";
import ShopOccasion from "./COMPONENTS/Occassion";
import Categories from "./COMPONENTS/Categories";
import Bestseller from "./COMPONENTS/BestSeller";
import WhyChooseUs from "./COMPONENTS/WhyChooseus";
import FounderSection from "./COMPONENTS/FounderSection";
import Crafted from "./COMPONENTS/Crafted";
import Feedback from "./COMPONENTS/Feedback";
import ArtSection from "./COMPONENTS/ArtSection";
import StyledBy from "./COMPONENTS/Styled";
import Footer from "./COMPONENTS/Footer";

import Shop from "./SHOPE/Shopehero";
import PinkHeader from "./SHOPE/Header";
import ProductGrid from "./SHOPE/Product";
import Features from "./SHOPE/Features";

import AboutHero from "./ABOUT/AboutHero";
import StatsSection from "./ABOUT/StatusSection";
import ScrollToTop from "./ScrollTop";
import OurApproach from "./ABOUT/OurApproach";
import StoryBehind from "./ABOUT/StoryBehind";
import StayInspired from "./ABOUT/SatyInspired";
import CardsSection from "./ABOUT/CardSection";
import VideoSection from "./ABOUT/VideoSection";
import Visionaries from "./ABOUT/Visionaries";

import ContactHero from "./CONTACTUS/ContactHero";
import Contact from "./CONTACTUS/Contact";

import ProductDetail from "./SINGLE PRODUCT/SinglePro";
import Breadcrumb from "./SINGLE PRODUCT/Breadcrumb";
import ProductTabs from "./SINGLE PRODUCT/ProductTab";
import RelatedProducts from "./SINGLE PRODUCT/RelatedProduct";

import CartHero from "./CART/CartHero";
import CartInfo from "./CART/CartInfo";

import { CartProvider } from "./CartContext";

import Orders from "./SINGLE PRODUCT/Order";

import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./Terms&condition";
import RefundPolicy from "./Refund&CancellationPolicy";
import ShippingPolicy from "./ShippingPolicy";

import Checkoutinfo from "./CHECKOUT/Checkout";
import CheckoutHero from "./CHECKOUT/CheckoutHero";
import SliderLine from "./COMPONENTS/SliderLine";

// =========================
// HOME PAGE
// =========================
function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Hero />

      {isMobile ? (
        <>
          {/* MOBILE ORDER */}
          {/* <Categories /> */}
          <Bestseller />
          <SliderLine />
          <AboutSection />
        </>
      ) : (
        <>
          {/* DESKTOP ORDER */}
          <SliderLine />
          <AboutSection />
          <Categories />
          <Bestseller />
        </>
      )}

      <ShopOccasion />
      <StyledBy />
      <WhyChooseUs />
      <FounderSection />
      <Crafted />
      <Feedback />
      <ArtSection />
      <Footer />
    </>
  );
}

// =========================
// SHOP PAGE
// =========================
function ShopPage() {
  return (
    <>
      <PinkHeader />
      <Shop />
      <ProductGrid />
      <Features />
      <Footer />
    </>
  );
}

// =========================
// ABOUT PAGE
// =========================
function AboutUs() {
  return (
    <>
      <PinkHeader />
      <AboutHero />
      <StatsSection />
      <OurApproach />
      <StoryBehind />
      <StayInspired />
      <CardsSection />
      <VideoSection />
      <Visionaries />
      <Footer />
    </>
  );
}

// =========================
// CONTACT PAGE
// =========================
function ContactUs() {
  return (
    <>
      <PinkHeader />
      <ContactHero />
      <Contact />
      <Footer />
    </>
  );
}

// =========================
// SINGLE PRODUCT PAGE
// =========================
function SingleProduct() {
  return (
    <>
      <PinkHeader />
      <Breadcrumb />
      <ProductDetail />
      <ProductTabs />
      <Footer />
    </>
  );
}

// =========================
// CART PAGE
// =========================
function Cart() {
  return (
    <>
      <PinkHeader />
      <CartHero />
      <CartInfo />
      <Footer />
    </>
  );
}

// =========================
// CHECKOUT PAGE
// =========================
function Checkout() {
  return (
    <>
      <PinkHeader />
      <CheckoutHero />
      <Checkoutinfo />
      <Footer />
    </>
  );
}

// =========================
// PRIVACY POLICY
// =========================
function PrivacyPolicyPage() {
  return (
    <>
      <PinkHeader />
      <PrivacyPolicy />
      <Footer />
    </>
  );
}

// =========================
// TERMS & CONDITIONS
// =========================
function TermsConditionsPage() {
  return (
    <>
      <PinkHeader />
      <TermsConditions />
      <Footer />
    </>
  );
}

// =========================
// REFUND POLICY
// =========================
function RefundPolicyPage() {
  return (
    <>
      <PinkHeader />
      <RefundPolicy />
      <Footer />
    </>
  );
}

// =========================
// SHIPPING POLICY
// =========================
function ShippingPolicyPage() {
  return (
    <>
      <PinkHeader />
      <ShippingPolicy />
      <Footer />
    </>
  );
}

// =========================
// APP
// =========================
function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <CartProvider>
        <Router>
          <ScrollToTop />

          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/shop" element={<ShopPage />} />

            <Route path="/about" element={<AboutUs />} />

            <Route path="/contact" element={<ContactUs />} />

            <Route path="/product/:id" element={<SingleProduct />} />

            <Route path="/cart" element={<Cart />} />

            <Route path="/checkout" element={<Checkout />} />

            <Route path="/orders" element={<Orders />} />

            <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />

            <Route path="/termsconditions" element={<TermsConditionsPage />} />

            <Route path="/refundpolicy" element={<RefundPolicyPage />} />

            <Route path="/shippingpolicy" element={<ShippingPolicyPage />} />
          </Routes>
        </Router>
      </CartProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
